export { default } from './assignInWith.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/extendWith.js
// module id = 388
// module chunks = 0